export const management = {
  routes: [
    {
      path: "/management/question",
      component: () => import("../management-question-view"),
    },
    {
      path: "/management/question-set",
      component: () => import("../management-question-set-view"),
    },
    {
      path: "/management/question-set/create",
      component: () => import("../management-question-set-detail"),
    },
    {
      path: "/management/question-set/:id",
      component: () => import("../management-question-set-detail"),
    },
  ],
};

export const platform = {
  routes: [
    {
      path: "/question-set",
      component: () => import("../account-question-set"),
    },
    {
      path: "/question-set/answering/:id",
      component: () => import("../account-question-set-answering"),
    },
  ],
};
export const workspace = {
  routes: [
    {
      path: "/workspace/library/question",
      component: () => import("../workspace-question-view"),
    },
    {
      path: "/workspace/library/question-set",
      component: () => import("../workspace-question-set-view"),
    },
    {
      path: "/workspace/library/question-set/create",
      component: () => import("../workspace-question-set-detail"),
    },
    {
      path: "/workspace/library/question-set/:id",
      component: () => import("../workspace-question-set-detail"),
    },
  ],
};

export const organization = {
  routes: [
    {
      path: "/organization/question-set/answering/:id",
      component: () => import("../organization-question-set-answering"),
    },
  ],
};

export const fwsed = {
  routes: [
    {
      path: "/fwsed/question-set/answering/:id",
      component: () => import("../organization-question-set-answering"),
    },
  ],
};
